var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.isLaunched)?_c('router-view'):_c('Launcher'),_c('UpdateDialog',{attrs:{"open":_vm.updateDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }